<template>
  <div class="navbar">
    <a 
      class="collapse-btn" 
      @click="$emit('show-menu')">
      <svg-icon icon-class="collapse" />
    </a>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item 
        v-for="item in routeMatched"
        :key="item.name">
        {{item.title}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <a 
      class="user-btn"
      @click="$emit('show-user')">
      <svg-icon icon-class="user" />
      <span>{{ userInfo ? userInfo.u_name : '未登录'}}</span>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userInfo']),
    routeMatched(){
      return this.$route.matched.map(item => 
      item.meta && item.meta.title
      ? ({
        name: item.name,
        title: item.meta.title
        })
      : null
      ).filter(item => item != null)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar{
  width: 100%;
  height: 4.31rem;
  background-color: #FFF;
  border-bottom: solid 0.0175rem #e6e6e6;
  box-shadow: 0 0 0.175rem rgba(0,0,0,.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.225rem;
  box-sizing: border-box;

  .collapse-btn,
  .user-btn{
    display: flex;
    align-items: center;
  }

  .collapse-btn{
    .svg-icon{
      font-size: 1.575rem;
    }
  }

  .user-btn{
    padding-right: .35rem;

    .svg-icon{
      font-size: 1.4rem;
      margin-right: .175rem;
    }
    
    span{
      font-size: 1.225rem;
    }
  }

  .el-breadcrumb{
    flex: 1;
    padding-left: 0.862rem;
    font-size: 1.05rem;

    >>> .el-breadcrumb__inner{
      color: $text3;
    }

    >>> .el-breadcrumb__separator{
      margin-left: 0;
      margin-right: .21rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Navbar.vue